export default new class Pagination {
  constructor() {
    this.sListWrapperClass = '_events_wrapper';
    this.sPaginationWrapperClass = '_events_pagination_wrapper';
    this.sButtonClass = '_events_pagination_button';

    this.handler();
  }

  /**
   * @description Handler.
   */
  handler() {
    $(document).on('click', `.${this.sPaginationWrapperClass}`, (obEvent) => {
      this.obButton = $(obEvent.target);
      this.obButton.attr('disabled', 'disabled');

      const iPage = this.obButton.attr('data-page');

      $.request('onInit', {
        data: {
          'page': iPage,
        },
        update: {
          'events/prev-events': `@.${this.sListWrapperClass}`,
          'events/pagination': `.${this.sPaginationWrapperClass}`
        },
      });
    });
  }
}();
